import type { NotaPublicaCard } from '@ahora-patagonia/contracts';
import { SIZES } from '../../../shared/media/srcset.js';
import { GrillaDeTarjetas } from './GrillaDeTarjetas.js';

export interface PlantillaTiraProps {
  notas: NotaPublicaCard[];
  /** Posición numerada sobre la foto: la disposición con la que se dibuja "Más leídas". */
  numerada?: boolean;
  /** Con qué número arranca (la segunda página del ranking empieza en 5, no en 1). */
  inicio?: number;
}

/**
 * Plantilla B — la tira: 4 notas con foto. Lista vertical con miniatura en teléfono no:
 * acá la foto es 16:9 arriba; 1 columna en 390, 2 en 768, 4 en 1440 (handoff §1.2).
 *
 * Una página corta no necesita rellenos: en el bloque paginado todas las páginas conviven en el
 * riel, así que el alto lo fija la más larga y no salta al pasar de una a otra.
 *
 * El corte a 4 es lo que la hace una **página**: lo que sobra lo dibuja la página siguiente del riel.
 * Su hermana, `PlantillaCuadricula`, es la misma grilla sin ese corte.
 */
export function PlantillaTira({ notas, numerada = false, inicio = 1 }: PlantillaTiraProps) {
  return (
    <GrillaDeTarjetas
      notas={notas.slice(0, 4)}
      columnas={{ xs: 1, sm: 2, lg: 4 }}
      sizes={SIZES.tarjeta}
      numerada={numerada}
      inicio={inicio}
    />
  );
}
